import React from 'react';
import './global.css';
import JWTAuthProvider from './services/JWTAuthProvider';
import Routes from './services/Routes';

export default function App() {
  return (
      <JWTAuthProvider>
        <Routes />
      </JWTAuthProvider>
  );
}